import React from 'react';

import { Typography } from '@material-ui/core';

import { Currency } from '../../../weborder/Api';
import { ToCurrency } from '../../../weborder/BasketControl';

type Props = {
  className?: string;
  Currency: Currency;
  currentLanguage: string;
  Extra?: string;
  Price: number;
};

export function Price(props: Props): JSX.Element {
  const {
    Currency: currency,
    currentLanguage,
    Extra: extra,
    Price: price,
  } = props;

  return (
    <Typography data-fd="voucher-price" tabIndex={0}>
      {extra}
      {ToCurrency(price, currency, currentLanguage)}
    </Typography>
  );
}
